module.exports = __webpack_public_path__ + "img/p1-mobile.527cf954.png";